import { del, executeApp, get, post } from '@/utils/request'
import { CHAT } from '@/api/defineRouting'

export function fetchChatStopResponding<T = any>(text: string, messageId: string, conversationId: string) {
  return post<T>({
    url: '/chat-abort',
    data: { text, messageId, conversationId },
  })
}

export function fetchCreateChatRoom<T = any>(agent_id: string, data: any) {
  return post<T>({
    url: `/interactions-service/conversations/messages/send?agent_id=${agent_id}`,
    data: {
      content: data?.text || '',
      conversation_id: data?.conversation_id || '',
      response_mode: data?.response_mode || 'blocking',
      ...(data?.files && { files: data.files }),
      ...(data?.task && { task: data.task }),
      ...(data?.model && { model: data.model }),
    },
    adapter: 'fetch',
    responseType: 'stream',
    timeout: 600000, // 5 minutes timeout for streaming
  })
}

export function uploadFileChat<T = any>(agent_id: any, formData: any) {
  return post<T>({
    url: `/interactions-service/conversations/file/upload?agent_id=${agent_id}`,
    data: formData,
  })
}

export function fetchUpdateChatRoomUsingContext<T = any>(using: boolean, roomId: number) {
  return post<T>({
    url: '/room-context',
    data: { using, roomId },
  })
}

export function getConversations(agent_id: string, page = 1, page_size = 20) {
  return post<any>({
    url: '/interactions-service/conversations',
    data: {
      agent_id,
      page,
      page_size,
    },
  })
}

export function getMessageByConversation(conversation_id: string, page = 1, page_size = 20) {
  return post<any>({
    url: '/interactions-service/conversations/messages',
    data: {
      conversation_id,
      page,
      page_size,
    },
  })
}

export function renameConversation(data: any) {
  return post<any>({ url: '/interactions-service/conversations/rename', data })
}

export function deleteConversation(id: string) {
  return del<any>({ url: `/interactions-service/conversations/${id}/delete` })
}

export function pinConversation(id: string) {
  return post<any>({ url: `/interactions-service/conversations/${id}/pin` })
}

export function createConfigShareLink(id: any, data: any) {
  return post<any>({
    url: `/dify-service/sites/create/${id}`,
    data,
  })
}

export function resetUrlShare(agentId: string) {
  return post<any>({
    url: `/dify-service/sites/reset/${agentId}`,
  })
}

export function getAppCodeByAgent(agent_id: string) {
  return get<any>({
    url: `/dify-service/sites/sites_code/${agent_id}`,
  })
}

export function getConfigShareLink(id: string) {
  return get<any>({
    url: `/dify-service/sites/sites/${id}`,
  })
}

export function getPassport(code: string) {
  return get<any>({
    url: `/dify-service/sites/passport/${code}`,
  })
}

export function getMessagePublic(page = 1, page_size = 20) {
  return post<any>({
    url: '/interactions-service/messages_public',
    data: {
      page,
      page_size,
    },
  })
}

export function getMessagePublicByConversation(conversation_id: string, page = 1, page_size = 20) {
  return post<any>({
    url: '/interactions-service/messages_public/messages',
    data: {
      conversation_id,
      page,
      page_size,
    },
  })
}

export function renameMessagePublic(id: string, data: { title: string }) {
  return post<any>({ url: `/interactions-service/messages_public/${id}/rename`, data })
}

export function deleteMessagePublic(id: string) {
  return del<any>({ url: `/interactions-service/messages_public/${id}/delete` })
}

export function pinMessagePublic(id: string) {
  return post<any>({ url: `/interactions-service/messages_public/${id}/pin` })
}

export function sendMessagePublic<T>(data: any) {
  return post<T>({
    url: '/interactions-service/messages_public/messages/send',
    data: { content: data?.text || '', conversation_id: data?.conversation_id || '', response_mode: data?.response_mode || 'blocking', model: data?.model },
    adapter: 'fetch',
    responseType: 'stream',
    timeout: 300000, // 5 minutes timeout for streaming
  })
}

export function getPrompIntroChatPublic() {
  return get<any>({ url: '/dify-service/sites/agent' })
}

export function getConfigChatPublic() {
  return get<any>({ url: '/dify-service/sites/sites' })
}

export function searchConversations<T = any>(data: any) {
  return executeApp<T>(CHAT.SEARCH, data, 'post',
  )
}
